var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-player-component",on:{"click":_vm.handleClickBtn}},[_c('player-style',{attrs:{"playing":_vm.playing,"duration":_vm.duration,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }